"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var directionMap = {
  right: 'rotate(0)',
  down: 'rotate(90)',
  left: 'rotate(180)',
  up: 'rotate(270)'
};

var Chevron = function Chevron(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$accessibleTitle = _ref.accessibleTitle,
      accessibleTitle = _ref$accessibleTitle === void 0 ? 'Chevron' : _ref$accessibleTitle,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'right' : _ref$direction,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'img' : _ref$role,
      otherProps = _objectWithoutProperties(_ref, ["size", "color", "accessibleTitle", "direction", "role"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: role,
    style: {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    },
    viewBox: "0 0 16 16",
    transform: directionMap[direction]
  }, otherProps), /*#__PURE__*/_react["default"].createElement("title", null, accessibleTitle), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M9.478 8L4.306 2.795a1.056 1.056 0 0 1 0-1.487 1.04 1.04 0 0 1 1.478 0l5.91 5.948c.408.411.408 1.077 0 1.488l-5.91 5.948a1.04 1.04 0 0 1-1.478 0 1.056 1.056 0 0 1 0-1.487L9.478 8z"
  })));
};

Chevron.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  accessibleTitle: _propTypes["default"].string,
  direction: _propTypes["default"].string,
  role: _propTypes["default"].string
};
var _default = Chevron;
exports["default"] = _default;